import React, { useContext, useEffect } from "react";
import Hero from "../Components/Contact/Hero";
import Information from "../Components/Contact/Information";
import { AppContext } from "../Contexts/AppContext";

const Contact = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    localStorage.setItem("current", "default");
    context.setCurrent("default");
  }, [context]);
  return (
    <div>
      <Hero />
      <Information />
    </div>
  );
};

export default Contact;
